import './usp-module.scss';

import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css';

class USPSlider {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-usp-slider',
            sliderAttr: 'main',
            slideAttr: 'slide'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$root = $element;
        this.$container = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$slides = this.$root.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);
        this.$prevBTN = this.$container.querySelector('[data-swiper-prev]');
        this.$nextBTN = this.$container.querySelector('[data-swiper-next]');
        this.slider = null;

        if (this.$container && this.$slides.length > 1) {
            this.initialize();
        }
    }

    initialize () {
        this.checkSize();
    }

    checkSize () {
        if (this.$slides.length > 1) {
            if (this.slider === null) {
                this.initSlider();
            }
        } else {
            if (this.slider !== null) {
                this.destroySlider();
            }
        }
    }

    initSlider () {
        this.slider = new Swiper(this.$container, {
            modules: [Navigation, A11y],
            speed: 500,
            effect: 'fade',
            slidesPerView: 'auto',
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide'
            },
            navigation: {
                prevEl: this.$prevBTN,
                nextEl: this.$nextBTN,
                addIcons: false,
            }
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}

export { USPSlider };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$USPSlider = $context.querySelectorAll('[data-usp-slider="root"]');

        for (let i = 0; i < $$USPSlider.length; i++) {
            const $USPSlider = $$USPSlider[i];
            const USPSliderAPI = new USPSlider($USPSlider);
            $USPSlider.API = USPSliderAPI;
        }
    }
});
